export const usePlaceTransformation = () => {
  const route = useRoute()

  function getRoutePlaceInfo() {
    const basePaths = Array.isArray(route.params?.place) ? route.params.place : [route.params.place]

    const keyword = route.params?.keyword as string | null

    return {
      basePath: basePaths.join('/'),
      keyword: keyword
    }
  }

  return {
    getRoutePlaceInfo
  }
}
